import React, { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import api, { setToken } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import Loading from "@/components/Loading";

export default function AuthCallback() {
  const navigate = useNavigate();
  const location = useLocation();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = location.hash || window.location.hash;
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? decodeURIComponent(match[1]) : null;

    (async () => {
      if (!sessionId) {
        navigate("/login", { replace: true });
        return;
      }
      try {
        const { data } = await api.post("/auth/session", { session_id: sessionId });
        if (data.session_token) setToken(data.session_token);
        setUser(data.user);
        window.history.replaceState({}, document.title, "/");
        const u = data.user;
        if (!u.role) navigate("/onboarding", { replace: true });
        else if (u.role !== "admin" && !u.admin_approved) navigate("/pending", { replace: true });
        else navigate("/", { replace: true });
      } catch (e) {
        navigate("/login", { replace: true });
      }
    })();
  }, [location.hash, navigate, setUser]);

  return <Loading label="Authenticating…" />;
}
